import { derived, writable } from "svelte/store";
export const contactStore = writable(null);
export const hasLeatAccount = derived(contactStore, ($contact) => $contact?.contact !== null);
